import React from "react";
import { Row, Col, Tooltip } from "antd";
import { Info } from "@material-ui/icons";
import { UPLOAD_TYPE } from "../uploadTypeEnum";

const exampleCSV = `date,site,solar_on,solar_off
03/01/26,makro_chumphon,1500.5,200.3
03/02/26,makro_pattaya,1200,150.8`;

const downloadExampleCSV = () => {
  const blob = new Blob([exampleCSV], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "example_daily_update.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const dailyUpdateCSVUploadConfig = {
  modal: {
    title: () => (
      <>
        Example CSV Format{"  "}
        <Tooltip
          overlayClassName="custom-tooltip-wide"
          title={
            <>
              <p className="custom-small-font" style={{ textIndent: "2em" }}>
                The CSV file must contain the following columns:
              </p>
              <ul className="custom-small-font">
                <li><b>date</b> — Date of the data (MM/DD/YY)</li>
                <li><b>site</b> — Site table_name</li>
                <li><b>solar_on</b> — Solar ON production value</li>
                <li><b>solar_off</b> — Solar OFF production value</li>
              </ul>
            </>
          }
          placement="bottom"
        >
          <Info />
        </Tooltip>
      </>
    ),
    content: () => (
      <>
        <Row>
          <Col span={24}>
            <p className="custom-medium-font" style={{ textIndent: "2em" }}>
              Upload a CSV to replace daily solar ON/OFF values and recalculate
              monthly aggregates. Each row calls the same logic as the Node-RED
              daily update endpoint.
            </p>
          </Col>
        </Row>
        <Row style={{ marginTop: "15px" }}>
          <Col span={24}>
            <p className="custom-medium-font"><b>Example CSV:</b></p>
            <pre style={{ background: "#f5f5f5", padding: "10px", fontSize: "12px", overflowX: "auto" }}>
{exampleCSV}
            </pre>
          </Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>
          <Col span={24}>
            <button className="btn btn-default btn-sm" onClick={downloadExampleCSV}>
              Download Example CSV
            </button>
          </Col>
        </Row>
      </>
    ),
  },
  form: {
    title: UPLOAD_TYPE.DAILY_SOLAR,
    description:
      "Upload a CSV file to update daily production data (solar ON/OFF, irradiance). Each row updates one site-date and recalculates monthly aggregates.",
    upload: {
      uploadUrl: "/daily/upload_update_daily_monthly",
      maxCount: 1,
      accept: ".csv",
      isInvalid: (file) => {
        const fileName = file.name.toLowerCase();
        if (!fileName.endsWith(".csv")) return "You can only upload CSV files!";
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) return "File must be smaller than 5MB!";
      },
    },
  },
};
